import { Controller } from 'react-hook-form';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

function ControlledSwitch({ name, control, label, trueValue = true, falseValue = false, className, style, ...switchProps }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Switch
              checked={field.value === trueValue}
              onChange={(e) => {
                field.onChange(e.target.checked ? trueValue : falseValue);
              }}
              color="primary"
              {...switchProps}
            />
          }
          label={typeof label === 'function' ? label(field.value) : label}
          className={className}
          style={style}
        />
      )}
    />
  );
}

export default ControlledSwitch;